module.exports = __webpack_public_path__ + "static/media/delogo60.2f9f567d.png";